import { APIService } from "services";

export const getVw_Zilla = async (pageNo,pageSize,search) => {
    let res;
    if(search.length===0) {
        res = await getAllVw_Zilla(pageNo,pageSize);
    }
    else{
        try {
            res = await searchVw_Zilla(search,pageNo,pageSize);
        } catch(err) {
             return { records:[], totalCount:0 }
        }
    }
    if(res && res.data){
    return res.data;
    }else{
    return { records:[], totalCount:0 }
    }
    
}


export const getAllVw_Zilla = (pageNo,pageSize) => {
return APIService.api().get(`/vw_zilla/?pageNo=${pageNo}&pageSize=${pageSize}`)
}
export const getOneVw_Zilla = (zilla_id) => {
return APIService.api().get(`/vw_zilla/${zilla_id}`)
}
export const searchVw_Zilla = (searchKey,pageNo,pageSize) => {
return APIService.api().get(`/vw_zilla/search/${searchKey}/?pageNo=${pageNo}&pageSize=${pageSize}`)
}
